import { autoUpdate, flip, offset, shift, useDismiss, useFloating, useHover, useInteractions } from '@floating-ui/react'
import PropTypes from 'prop-types'
import React, { useState } from 'react'

import { CwsSection } from '../../cms-web-styleguide-exports'

/* Example usage:
  <Tooltip content={<SoldOutSailTooltipContent />}>
    <CwsIcon icon="notice-info-more" size="20px" />
  </Tooltip>
*/

function Tooltip({ content, children }) {
  const [isOpen, setIsOpen] = useState(false)

  const { refs, floatingStyles, context } = useFloating({
    placement: 'top',
    middleware: [offset(8), flip(), shift()],
    open: isOpen,
    onOpenChange: setIsOpen,
    whileElementsMounted: autoUpdate,
    strategy: 'fixed'
  })

  const dismiss = useDismiss(context)
  const hover = useHover(context)

  const { getReferenceProps, getFloatingProps } = useInteractions([dismiss, hover])

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <div ref={refs.setReference} {...getReferenceProps()}>
        {children}
      </div>

      {isOpen && (
        <div
          ref={refs.setFloating}
          {...getFloatingProps()}
          style={{
            ...floatingStyles,
            zIndex: 1000
          }}
        >
          <CwsSection
            backgroundColor="white"
            className="cws-py-xs cws-px-20 cws-rounded-8 cws-shadow-drop-l"
            variant="div"
          >
            {content}
          </CwsSection>
        </div>
      )}
    </div>
  )
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired
}

export default Tooltip
